module.exports = __webpack_public_path__ + "img/avatar.431a0088.jpg";